import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Section } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function Phonics({ ...props }) {
	const { language, account } = useContext(CoreAdoptionContext)
	return (
		<Section margin="mt-20" id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle title={language === 'english' ? 'Explicit Systematic Phonics' : 'Fonética sistemática explícita'} />
			<Tabs selectedTabClassName="text-ab-100 border-ab-100">
				<div className="px-4 sm:px-0">
					<TabList className="mt-6 flex flex-wrap">
						{account?.english_grades && account.english_grades.length > 0 && (
							<>
								<Tab className="mx-2 mr-2 mb-3 flex min-w-max flex-grow cursor-pointer items-center justify-center rounded border px-2 py-3 text-center text-base shadow-sm lg:text-lg">
									{language === 'english' ? 'English Example Lesson' : 'Ejemplo de lección para inglés'}
								</Tab>
								<Tab className="ml-0 mr-2 mb-3 flex min-w-max flex-grow cursor-pointer items-center justify-center rounded border px-2 py-3 text-center text-base shadow-sm sm:ml-4 lg:text-lg">
									{language === 'english' ? 'English Phonics Scope & Sequence' : 'Secuencia fonética para inglés'}
								</Tab>
							</>
						)}
						{account?.spanish_grades && account.spanish_grades.length > 0 && (
							<>
								<Tab className="mx-2 mr-2 mb-3 flex min-w-max flex-grow cursor-pointer items-center justify-center rounded border px-2 py-3 text-center text-base shadow-sm lg:text-lg">
									{language === 'english' ? 'Spanish Example Lesson' : 'Ejemplo de lección para español'}
								</Tab>
								<Tab className="ml-0 mr-2 mb-3 flex min-w-max flex-grow cursor-pointer items-center justify-center rounded border px-2 py-3 text-center text-base shadow-sm sm:ml-4 lg:text-lg">
									{language === 'english' ? 'Spanish Phonics Scope & Sequence' : 'Secuencia fonética para español'}
								</Tab>
							</>
						)}
						<Tab className="ml-0 mr-2 mb-3 flex min-w-max flex-grow cursor-pointer items-center justify-center rounded border px-2 py-3 text-center text-base shadow-sm sm:ml-4 lg:text-lg">
							FSTK Scope & Sequence K-2
						</Tab>
					</TabList>
				</div>
				{account?.english_grades && account.english_grades.length > 0 && (
					<>
						<TabPanel>
							<Resource title="English Example Lesson" maxHeight={800} noZoom />
						</TabPanel>
						<TabPanel>
							<div className="flex justify-center">
								<Resource title="English Phonics" maxHeight={800} noZoom />
							</div>
						</TabPanel>
					</>
				)}
				{account?.spanish_grades && account.spanish_grades.length > 0 && (
					<>
						<TabPanel>
							<Resource title="Spanish Example Lesson" maxHeight={800} noZoom />
						</TabPanel>
						<TabPanel>
							<div className="flex justify-center">
								<Resource title="Spanish Phonics" noZoom />
							</div>
						</TabPanel>
					</>
				)}
				<TabPanel>
					<div className="flex gap-4">
						<Resource logResourceView={{ type: 'resource' }} title="Grade K | FSTK Scope & Sequence" text="FSTK Scope & Sequence | Grade K" />
						<Resource logResourceView={{ type: 'resource' }} title="Grade 1 | FSTK Scope & Sequence" text="FSTK Scope & Sequence | Grade 1" />
						<Resource logResourceView={{ type: 'resource' }} title="Grade 2 | FSTK Scope & Sequence" text="FSTK Scope & Sequence | Grade 2" />
					</div>
				</TabPanel>
			</Tabs>
		</Section>
	)
}
